import { DaTeacher } from '../generated/DaTeacher';
import { ShiftTable } from '../generated/ShiftTable';
import { Teacher } from '../generated/Teacher';
import { LessonDTO } from './LessonDTO';

export class ScheduledLessonsDTO {
  shift_table: ShiftTable = new ShiftTable();
  teacher: Teacher = new Teacher();
  lessons: LessonDTO[] = [];
  da_teacher: DaTeacher = new DaTeacher();
}
